import Event from '../../core/Event';
import EstimationPeriod from '../../../domain/EstimationPeriod';

export default class EstimationPeriodUpdateSucceed extends Event {
    public static type = 'EstimationPeriodUpdateSucceed';

    constructor(public readonly estimationPeriod: EstimationPeriod) {
        super(EstimationPeriodUpdateSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/EstimationPeriodUpdateSucceed.ts